// When the listings were last refreshed (the end of the last successful nightly scan), from
// GET /listings/active/status. Fetched once per page load and shared by everything that shows it.
import { useEffect, useState } from 'react';
import { apiFetch } from './edgePayloads.js';

const STATUS_ENDPOINT = 'https://api.xn--omrdeskollen-vcb.nu/listings/active/status';

let statusPromise = null;
const loadUpdatedAt = () => {
    if (!statusPromise) {
        statusPromise = apiFetch(STATUS_ENDPOINT, { headers: { Accept: 'application/json' } })
            .then((response) => (response.ok ? response.json() : null))
            .then((body) => (body?.updatedAt ? new Date(body.updatedAt) : null))
            .then((date) => (date && !Number.isNaN(date.getTime()) ? date : null))
            .catch(() => null);
    }
    return statusPromise;
};

export const useListingsUpdatedAt = () => {
    const [updatedAt, setUpdatedAt] = useState(null);
    useEffect(() => {
        let active = true;
        loadUpdatedAt().then((date) => {
            if (active) setUpdatedAt(date);
        });
        return () => {
            active = false;
        };
    }, []);
    return updatedAt;
};

// "Bostäder uppdaterade idag 04:55" / "igår 04:55" / "16 okt 04:55".
export const formatListingsUpdated = (date, swedish) => {
    if (!date) return '';
    const locale = swedish ? 'sv-SE' : 'en-GB';
    const time = date.toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
    const dayStart = (value) => new Date(value.getFullYear(), value.getMonth(), value.getDate()).getTime();
    const days = Math.round((dayStart(new Date()) - dayStart(date)) / 86400000);
    const day = days === 0 ? (swedish ? 'idag' : 'today')
        : days === 1 ? (swedish ? 'igår' : 'yesterday')
            : date.toLocaleDateString(locale, { day: 'numeric', month: 'short' });
    return swedish ? `Bostäder uppdaterade ${day} ${time}` : `Homes updated ${day} ${time}`;
};
